import Box from "@mui/material/Box";
import Modal from "@mui/material/Modal";
import { IconButton } from "@mui/material";
import Close from "@mui/icons-material/Close";
const style = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  bgcolor: "background.paper",
  height: "fit-content",
  borderRadius: "10px",
  boxShadow: 24,
};

export default function AdmissionModal({ open, setOpen, src }: any) {
  const handleOpen = () => setOpen(true);
  const handleClose = () => setOpen(false);

  return (
    <Modal
      open={open}
      onClose={handleClose}
      aria-labelledby="modal-modal-title"
      aria-describedby="modal-modal-description"
      sx={{
        zIndex: (theme) => theme.zIndex.modal + 15,
      }}
    >
      <Box sx={style}>
        <IconButton sx={{ float: "right" }} onClick={handleClose}>
          <Close />
        </IconButton>
        <Box
          sx={{
            width: { xs: "90vw", md: "50vw" },
            height: { xs: "80vh", md: "80vh" },
            borderRadius: "10px",
          }}
        >
          <img src={src} alt="Admission Popup" width="100%" height="100%" />
        </Box>
      </Box>
    </Modal>
  );
}
